import { createSlice } from "@reduxjs/toolkit";

export const occupationDetailsSlice = createSlice({
  name: "occupationDetails",
  initialState: {
    companyDetailsList: [],
    rConpanyList: [],
    companyRelationDetailsList: [],
    rCompanyRelationList: [],
    errors: {},
  },
  reducers: {
    setOccupationType: (state, action) => {
      state.occupationType = action.payload;
      state.errors.occupationTypeError = {};
      state.op = "U";
    },
    setBusinessType: (state, action) => {
      state.businessType = action.payload;
      state.errors.businessTypeError = {};
      state.op = "U";
    },
    setOrganizationName: (state, action) => {
      state.organizationName = action.payload;
      state.errors.organizationNameError = {};
      state.op = "U";
    },
    setAddress: (state, action) => {
      state.address = action.payload;
      state.errors.addressError = {};
      state.op = "U";
    },
    setDesignation: (state, action) => {
      state.designation = action.payload;
      state.errors.designationError = {};
      state.op = "U";
    },
    setIdNo: (state, action) => {
      state.docId = action.payload;
      state.errors.docIdError = {};
      state.op = "U";
    },
    setFinancialDetails: (state, action) => {
      state.financialDetails = action.payload;
      state.errors.financialDetailsError = {};
      state.op = "U";
    },
    setFinancialDetailsDesc: (state, action) => {
      state.financialDetailsDesc = action.payload;
    },
    setOccupationTypeDesc: (state, action) => {
      state.occupationTypeDesc = action.payload;
    },
    setSecurtitesTrading: (state, action) => {
      state.securtitesTrading = action.payload;
      state.errors.securtitesTradingError = {};
    },
    setCompanyName: (state, action) => {
      state.companyName = action.payload;
      state.errors.companyNameError = {};
    },
    setCompanyDesignation: (state, action) => {
      state.companyDesignation = action.payload;
      state.errors.companyDesignationError = {};
    },
    setCompanyDesignationDesc: (state, action) => {
      state.companyDesignationDesc = action.payload;
    },
    setCompanyNameOrRelation: (state, action) => {
      state.companyNameOrRelation = action.payload;
      state.errors.companyNameOrRelationError = {};
    },
    setCompanyNameRelation: (state, action) => {
      state.companyNameRelation = action.payload;
      state.errors.companyNameRelationError = {};
    },
    setCompanyRelationDesignation: (state, action) => {
      state.companyRelationDesignation = action.payload;
      state.errors.companyRelationDesignationError = {};
    },
    // setCompanyRelationDesignation: (state, action) => {
    //   state.companyRelationDesignation = action.payload;
    //   if (action.payload !== "O") {
    //     state.companyRelationDesignationOthers = null;
    //     state.errors.companyRelationDesignationOthersError = {};
    //   }
    // },
    setCompanyNameOrRelationError: (state, action) => {
      if (!state.errors.companyNameOrRelationError) {
        state.errors.companyNameOrRelationError = {};
      }
      state.errors.companyNameOrRelationError.message = action.payload.message;
      state.errors.companyNameOrRelationError.section = action.payload.section;
    },

    setCompanyNameRelationError: (state, action) => {
      if (!state.errors.companyNameRelationError) {
        state.errors.companyNameRelationError = {};
      }
      state.errors.companyNameRelationError = {};
      state.errors.companyNameRelationError.message = action.payload.message;
      state.errors.companyNameRelationError.section = action.payload.section;
    },
    setCompanyRelationDesignationDesc: (state, action) => {
      state.companyRelationDesignationDesc = action.payload;
    },
    setRelationDesignationOthers: (state, action) => {
      state.companyRelationDesignationOthers = action.payload;
      state.errors.companyRelationDesignationOthers = {};
    },

    setCompanyRelationDesignationError: (state, action) => {
      if (!state.errors.companyRelationDesignationError) {
        state.errors.companyRelationDesignationError = {};
      }
      state.errors.companyRelationDesignationError.message = action.payload.message;
      state.errors.companyRelationDesignationError.section = action.payload.section;
    },
    setRelationDesignationOthersError: (state, action) => {
      if (!state.errors.companyRelationDesignationOthersError) {
        state.errors.companyRelationDesignationOthersError = {};
      }
      state.errors.companyRelationDesignationOthersError.message = action.payload.message;
      state.errors.companyRelationDesignationOthersError.section = action.payload.section;
    },
    setFromAD: (state, action) => {
      state.op = "U";
      state.fromAd = action.payload;
      state.errors.fromAdError = {};
    },
    setToAD: (state, action) => {
      state.op = "U";
      state.toAd = action.payload;
      state.errors.toAdError = {};
    },
    addCompanyDetails: (state, action) => {
      console.log(action);
      state.companyDetailsList.push({
        companyName: action.payload.companyName,
        companyDesignation: action.payload.companyDesignation,
        compDesignationDesc: action.payload.compDesignationDesc,
        designationOthers: action.payload.designationOthers,
        op: "I",
      });
      // state.op = 'U';
    },
    removeCompanyDetails: (state, action) => {
      state.companyDetailsList = state.companyDetailsList.filter((company) => {
        if (company.companyName !== action.payload) {
          return true;
        } else if (company.id) {
          state.rConpanyList.push(company.id);
        }
        return false;
      });
      // state.op = 'U';
    },
    addCompanyRelationDetails: (state, action) => {
      console.log(action);
      state.companyRelationDetailsList.push({
        companyNameOrRelation: action.payload.companyNameOrRelation,
        companyNameRelation: action.payload.companyNameRelation,
        companyRelationDesignation: action.payload.companyRelationDesignation,
        companyRelationDesignationDesc: action.payload.companyRelationDesignationDesc,
        designationOthers: action.payload.companyRelationDesignationOthers,
        fromAd: action.payload.fromAd,
        toAd: action.payload.toAd,
        op: "I",
      });
      // state.op = 'U';
    },
    removeCompanyRelationDetails: (state, action) => {
      state.companyRelationDetailsList = state.companyRelationDetailsList.filter((company) => {
        if (company.companyNameOrRelation !== action.payload) {
          return true;
        } else if (company.id) {
          state.rCompanyRelationList.push(company.id);
        }
        return false;
      });
      // state.op = 'U';
    },
    setOccupationDetailData: (state, action) => {
      if (action.payload.length) {
        const dta = action.payload[0];
        Object.keys(dta).forEach((key) => (state[key] = dta[key]));
      }
    },
    resetOccupationInvetmentCompanyData: (state, action) => {
      if (action.payload.length) {
        state.companyDetailsList = [
          ...state.companyDetailsList.filter((c) => c.id),
          ...action.payload,
        ];
        state.rConpanyList = [];
      }
    },
    resetOccupationInvestmentCompanyRelationList: (state, action) => {
      if (action.payload.length) {
        state.companyRelationDetailsList = [
          ...state.companyRelationDetailsList.filter((c) => c.id),
          ...action.payload,
        ];
        state.rCompanyRelationList = [];
      }
    },
    clearOccupationData: (state, action) => {
      state.op = "N";
      state.companyDetailsList.forEach((c) => (c.op = "N"));
    },
    setOccupationTypeError: (state, action) => {
      state.errors.occupationTypeError = {};
      state.errors.occupationTypeError.message = action.payload.message;
      state.errors.occupationTypeError.section = action.payload.section;
    },
    setBusinessTypeError: (state, action) => {
      state.errors.businessTypeError = {};
      state.errors.businessTypeError.message = action.payload.message;
      state.errors.businessTypeError.section = action.payload.section;
    },
    setOrganizationNameError: (state, action) => {
      if (!state.errors.organizationNameError) {
        state.errors.organizationNameError = {};
      }
      state.errors.organizationNameError.message = action.payload.message;
      state.errors.organizationNameError.section = action.payload.section;
    },
    setAddressError: (state, action) => {
      if (!state.errors.addressError) {
        state.errors.addressError = {};
      }
      state.errors.addressError.message = action.payload.message;
      state.errors.addressError.section = action.payload.section;
    },
    setDesignationError: (state, action) => {
      state.errors.designationError = {};
      state.errors.designationError.message = action.payload.message;
      state.errors.designationError.section = action.payload.section;
    },
    setDocIdError: (state, action) => {
      if (!state.errors.docIdError) {
        state.errors.docIdError = {};
      }
      state.errors.docIdError.message = action.payload.message;
      state.errors.docIdError.section = action.payload.section;
    },
    setFinancialDetailsError: (state, action) => {
      state.errors.financialDetailsError = {};
      state.errors.financialDetailsError.message = action.payload.message;
      state.errors.financialDetailsError.section = action.payload.section;
    },
    setOccupationTypeOthers: (state, action) => {
      state.occupationTypeOthers = action.payload;
    },
    setOccupationTypeOthersError: (state, action) => {
      if (!state.errors.occupationTypeError) {
        state.errors.occupationTypeError = {};
      }
      state.errors.occupationTypeError.message = action.payload.message;
      state.errors.occupationTypeError.section = action.payload.section;
    },
    setBusinessTypeOthers: (state, action) => {
      state.businessTypeOthers = action.payload;
    },
    setBusinessTypeOthersError: (state, action) => {
      if (!state.errors.businessTypeError) {
        state.errors.businessTypeError = {};
      }
      state.errors.businessTypeError.message = action.payload.message;
      state.errors.businessTypeError.section = action.payload.section;
    },
    setDesignationOthers: (state, action) => {
      state.designationOthers = action.payload;
    },
    clearOccupationDetailsError: (state) => {
      state.errors = {};
    },
    clearCompanyDetails: (state) => {
      state.companyName = "";
      state.companyDesignation = "";
    },
    clearCompanyRelationDetails: (state) => {
      state.companyNameOrRelation = "";
      state.companyNameRelation = "";
      state.companyRelationDesignation = "";
      state.fromAd = "";
      state.toAd = "";
    },
  },
});

export const {
  clearOccupationData,
  setOccupationDetailData,
  setOccupationType,
  resetOccupationInvetmentCompanyData,
  resetOccupationInvestmentCompanyRelationList,
  setBusinessType,
  setOrganizationName,
  setAddress,
  setDesignation,
  setIdNo,
  setFinancialDetails,
  setSecurtitesTrading,
  setCompanyName,
  setCompanyDesignation,
  addCompanyDetails,
  removeCompanyDetails,
  setCompanyDesignationDesc,
  setCompanyNameOrRelation,
  setCompanyNameRelation,
  setCompanyRelationDesignation,
  setCompanyRelationDesignationError,
  setCompanyNameOrRelationError,
  setCompanyNameRelationError,
  setRelationDesignationOthersError,
  setCompanyRelationDesignationDesc,
  setRelationDesignationOthers,
  companyNameOrRelation,
  companyNameOrRelationError,
  setFromAD,
  setToAD,
  setFinancialDetailsDesc,
  setOccupationTypeError,
  setBusinessTypeError,
  setOrganizationNameError,
  setAddressError,
  setDesignationError,
  setDocIdError,
  setFinancialDetailsError,
  setOccupationTypeOthers,
  setOccupationTypeOthersError,
  setBusinessTypeOthers,
  setBusinessTypeOthersError,
  setDesignationOthers,
  clearOccupationDetailsError,
  setOccupationTypeDesc,
  clearCompanyDetails,
  addCompanyRelationDetails,
  removeCompanyRelationDetails,
  clearCompanyRelationDetails
} = occupationDetailsSlice.actions;

export default occupationDetailsSlice.reducer;
